import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import HeaderItem from "ui/Header";
import Pages from "./Pages";
//@ts-ignore
import "./styles.css";
import SideMenuBar from "component/menu/SideMenu";
import { useLocation } from "react-router";
import { ErrorModal } from "ui/ErrorInfo";
import Loading from "ui/Loading";
import { useMenuItemStore } from "store/menuItem";
import { getMenuApi } from "api/menu";
import { findMenuItemByPath } from "utils/helper";
import { PageTypePath } from "utils/pages";
import { Toast } from "ui/Toast";
import { useUserStore } from "store";
import { UserRole } from "interface/user";
import { cookieAuthApi } from "api/auth";
import { useAuthStore } from "store/auth";
import GdprModal from "component/gdpr/GdprModal";
import { useOnlineUsersConnection } from "hooks/useOnlineUsers";
import { useOnlineUsersStore } from "store/onlineUsers";
import { useToastStore } from "store/toast";

const _allowedAccessPages = [
	//this is the  login user page,  users should eb able to access there page
	PageTypePath.UserProfiles,
	// this is the signature page, for different signature forms, to see this page access has already been given
	PageTypePath.Signature,
	PageTypePath.QuotaTransactions,
	PageTypePath.RegistrationOverview,
	PageTypePath.FisheryDepartmentLandingNotes,
	PageTypePath.FisheryDepartmentSalesNotes,
];

const adminAccessPages = [PageTypePath.NewUser];
const showHideMenuIcon = false;



const isAdmin = (roles: string[]) => {
	return roles.some(
		//	(role) => role === UserRole.Admin || role === UserRole.Firmaadministrator,
		(role) => role === UserRole.Admin,
	);
};

const isCompanyAdmin = (roles: string[]) => {
	return roles.some((role) => role === UserRole.Firmaadministrator);
};

const allowedAccessPages = (roles: string[], page: string) => {
	if (_allowedAccessPages.includes(page as PageTypePath)) {
		return true;
	}

	if (isAdmin(roles) || isCompanyAdmin(roles)) {
		return adminAccessPages.includes(page as PageTypePath);
	}
	return false;
};
const Home = () => {
	const [currentPage, setCurrentPage] = useState<string>(
		window.location.pathname || "/",
	);
	const [isMobileView, setIsMobileView] = useState<boolean>(() => {
		if (typeof window === "undefined") {
			return false;
		}
		return window.innerWidth < 768;
	});
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
	const [isMobileHeaderElevated, setIsMobileHeaderElevated] =
		useState<boolean>(false);
	const [mobileHeaderHeight, setMobileHeaderHeight] = useState<number>(120);
	const mobileHeaderRef = useRef<HTMLDivElement | null>(null);
	// const [loading, setLoading] = useState<boolean>(false);
	const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(false);

	let { path } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const { menuItems, setMenuItem } = useMenuItemStore();
	const { roles, loading, setStore, isAdmin, user } = useUserStore();
	const { incomingMessage, clearIncomingMessage } = useOnlineUsersStore();
	const { showWarning } = useToastStore();

	useOnlineUsersConnection();

	useEffect(() => {
		cookieAuthApi()
			.then((response) => {
				setStore(response.roles, response.user);
			})
			.catch(() => {
				navigate(`/login`);
			});
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 768);
		};

		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (incomingMessage) {
			//showWarning(`${incomingMessage.from}: ${incomingMessage.message}`, {
			//	duration: 60000,
			//	showCloseButton: true,
			//	position: "top-right",
			//});
			showWarning(`${incomingMessage.message}`, {
				duration: 60000,
				showCloseButton: true,
				position: "top-right",
			});
			clearIncomingMessage();
		}
	}, [incomingMessage]);

	useEffect(() => {
		if (!isMobileView && isMobileMenuOpen) {
			setIsMobileMenuOpen(false);
		}
	}, [isMobileView, isMobileMenuOpen]);

	useEffect(() => {
		if (path) {
			if (currentPage === path) return;
			setCurrentPage(path);
		} else {
			setCurrentPage("/");
		}
		sessionStorage.setItem("previousUrl", location.pathname);
	}, [path, loading]);

	useEffect(() => {
		if (isMobileView) {
			setIsMobileMenuOpen(false);
		}
	}, [location.pathname, isMobileView]);

	useEffect(() => {
		if (!isMobileView) {
			setMobileHeaderHeight(0);
			return;
		}

		const headerNode = mobileHeaderRef.current;
		if (!headerNode) {
			return;
		}

		const updateHeaderHeight = () => {
			setMobileHeaderHeight(headerNode.getBoundingClientRect().height);
		};

		updateHeaderHeight();

		if (typeof ResizeObserver === "undefined") {
			window.addEventListener("resize", updateHeaderHeight);
			return () => {
				window.removeEventListener("resize", updateHeaderHeight);
			};
		}

		const resizeObserver = new ResizeObserver(() => {
			updateHeaderHeight();
		});

		resizeObserver.observe(headerNode);
		window.addEventListener("resize", updateHeaderHeight);

		return () => {
			resizeObserver.disconnect();
			window.removeEventListener("resize", updateHeaderHeight);
		};
	}, [isMobileView]);

	useEffect(() => {
		if (!isMobileView) {
			setIsMobileHeaderElevated(false);
			return;
		}

		const updateHeaderElevation = (event?: Event) => {
			const eventTarget = event?.target;
			const targetScrollTop =
				eventTarget instanceof HTMLElement ? eventTarget.scrollTop : 0;
			const windowScrollTop =
				window.scrollY ||
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				0;

			setIsMobileHeaderElevated(targetScrollTop > 0 || windowScrollTop > 0);
		};

		updateHeaderElevation();
		window.addEventListener("scroll", updateHeaderElevation, true);

		return () => {
			window.removeEventListener("scroll", updateHeaderElevation, true);
		};
	}, [isMobileView, location.pathname]);

	useEffect(() => {
		if (loading) return;

		if (menuItems.length > 0) {
			if (!path) return;

			const allowPageAccess = findMenuItemByPath(menuItems, path as string);
			if (
				!allowPageAccess &&
				!allowedAccessPages(roles, path as PageTypePath)
			) {
				navigate(`/${PageTypePath.AccessDenied}`, {
					replace: true,
				});

				// navigate("/");
				return;
			}

			return;
		}

		getMenuApi()
			.then((response) => {
				if (
					path &&
					path !== "/" &&
					!allowedAccessPages(roles, path as PageTypePath)
				) {
					const allowPageAccess = findMenuItemByPath(response, path);
					if (
						!allowPageAccess &&
						!allowedAccessPages(roles, path as PageTypePath)
					) {
						//navigate("/");
						navigate(`/${PageTypePath.AccessDenied}`, { replace: true });

						return;
					}
				}
				setMenuItem(
					response.map((item) => ({
						...item,
						id: item.id.toString(),
						children: item.children
							? item.children.map((child) => ({
									...child,
									id: child.id.toString(),
								}))
							: null,
					})) as any,
				);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [path, loading]);

	const { twoFactorVerified, isLogin } = useAuthStore();

	useEffect(() => {
		if (isLogin && !twoFactorVerified) {
			navigate("/auth/verification/2fa");
		}
	}, [isLogin, twoFactorVerified]);

	if (!loading && user && user.hasSignedGdpr === false) {
		return <GdprModal />;
	}

	// if (loading) return <Loading show={loading} />;
	return (
		<div
			className="app-root"
			style={{
				backgroundColor: "#EDEFF0",
				// height: "100vh",
				// height: `calc(${pageHeight}px - 90px)`,
				width: "100%",
			}}
		>
			{isMobileView ? (
				<div
					className={`mobile-sticky-header-shell${
						isMobileHeaderElevated ? " mobile-sticky-header-shell-elevated" : ""
					}`}
					ref={mobileHeaderRef}
				>
					<div className="mobile-sticky-header-spacer">{""}</div>
					<div className="mobile-top-bar">
						<button
							type="button"
							onClick={() => setIsMobileMenuOpen(true)}
							aria-label="Open menu"
							title="Open menu"
							style={{
								border: "none",
								background: "transparent",
								minWidth: "44px",
								minHeight: "44px",
								padding: 0,
								cursor: "pointer",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<span
								aria-hidden="true"
								style={{
									display: "inline-flex",
									flexDirection: "column",
									justifyContent: "center",
									gap: "4px",
								}}
							>
								<span
									style={{
										width: "18px",
										height: "2px",
										backgroundColor: "#232626",
										borderRadius: "999px",
										display: "block",
									}}
								/>
								<span
									style={{
										width: "18px",
										height: "2px",
										backgroundColor: "#232626",
										borderRadius: "999px",
										display: "block",
									}}
								/>
								<span
									style={{
										width: "18px",
										height: "2px",
										backgroundColor: "#232626",
										borderRadius: "999px",
										display: "block",
									}}
								/>
							</span>
						</button>
						<img
							src={"/icon/surofi.svg"}
							alt="surofi"
							style={{ height: "28px" }}
							onClick={() => navigate("/")}
						/>
						<div style={{ minWidth: "44px", minHeight: "44px" }} />
					</div>
					<div className="mobile-sticky-header-content">
						<HeaderItem />
					</div>
				</div>
			) : (
				<div style={{ height: "40px" }}>{""}</div>
			)}

			{isMobileView && isMobileMenuOpen && (
				<div
					style={{
						position: "fixed",
						inset: 0,
						backgroundColor: "rgba(0, 0, 0, 0.25)",
						zIndex: 2000,
					}}
					onClick={() => setIsMobileMenuOpen(false)}
				>
					<div
						style={{
							width: "280px",
							height: "100dvh",
							backgroundColor: "#EDEFF0",
							paddingTop: "20px",
							paddingLeft: "16px",
							paddingRight: "12px",
							display: "flex",
							flexDirection: "column",
						}}
						onClick={(event) => event.stopPropagation()}
					>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								paddingBottom: "16px",
								flexShrink: 0,
							}}
						>
							<img
								src={"/icon/surofi.svg"}
								alt="surofi"
								style={{ height: "28px" }}
								onClick={() => {
									navigate("/");
									setIsMobileMenuOpen(false);
								}}
							/>
							<button
								type="button"
								onClick={() => setIsMobileMenuOpen(false)}
								aria-label="Close menu"
								title="Close menu"
								style={{
									border: "none",
									background: "transparent",
									minWidth: "44px",
									minHeight: "44px",
									cursor: "pointer",
									padding: 0,
									display: "inline-flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<span
									aria-hidden="true"
									style={{
										position: "relative",
										width: "18px",
										height: "18px",
										display: "inline-block",
									}}
								>
									<span
										style={{
											position: "absolute",
											top: "8px",
											left: 0,
											width: "18px",
											height: "2px",
											backgroundColor: "#232626",
											borderRadius: "999px",
											transform: "rotate(45deg)",
										}}
									/>
									<span
										style={{
											position: "absolute",
											top: "8px",
											left: 0,
											width: "18px",
											height: "2px",
											backgroundColor: "#232626",
											borderRadius: "999px",
											transform: "rotate(-45deg)",
										}}
									/>
								</span>
							</button>
						</div>
						<div
							style={{
								flex: 1,
								overflowY: "auto",
								WebkitOverflowScrolling: "touch",
							}}
						>
							<SideMenuBar currentPage={currentPage} />
						</div>
					</div>
				</div>
			)}
			<div
				className="home-layout-shell"
				style={{
					display: "flex",
					flexDirection: isMobileView ? "column" : "row",
					width: "100%",
					paddingTop: isMobileView ? mobileHeaderHeight : 0,
					// height: "calc(100% - 60px)",
				}}
			>
				{!isMobileView && (
					<div
						style={{
							minWidth: isSidebarCollapsed ? "60px" : "250px",
							width: isSidebarCollapsed ? "60px" : "250px",
							transition: "width 0.2s ease, min-width 0.2s ease",
							flexShrink: 0,
							position: "relative",
						}}
					>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: isSidebarCollapsed ? "center" : "space-between",
								paddingLeft: isSidebarCollapsed ? "0px" : "27px",
								paddingRight: "12px",
								minHeight: "36px",
							}}
						>
							{!isSidebarCollapsed && (
								<img
									src={"/icon/surofi.svg"}
									alt="surofi"
									style={{ height: "28px", cursor: "pointer" }}
									onClick={() => navigate("/")}
								/>
							)}
							<button
								type="button"
								onClick={() => setIsSidebarCollapsed((v) => !v)}
								aria-label={
									isSidebarCollapsed ? "Expand menu" : "Collapse menu"
								}
								title={isSidebarCollapsed ? "Expand menu" : "Collapse menu"}
								style={{
									border: "1px solid #d9dbdc",
									background: "#fff",
									borderRadius: "50%",
									width: "28px",
									height: "28px",
									cursor: "pointer",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									padding: 0,
									boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
									flexShrink: 0,
								}}
							>
								<span
									aria-hidden="true"
									style={{
										display: "inline-block",
										width: "10px",
										height: "10px",
										borderTop: "2px solid #232626",
										borderRight: "2px solid #232626",
										transform: isSidebarCollapsed
											? "rotate(45deg)"
											: "rotate(225deg)",
										marginLeft: isSidebarCollapsed ? "-2px" : "2px",
										transition: "transform 0.2s ease",
									}}
								/>
							</button>
						</div>
						<div style={{ marginTop: "20px" }}>
							<SideMenuBar
								currentPage={currentPage}
								isCollapsed={isSidebarCollapsed}
							/>
						</div>
					</div>
				)}

				<div
					className="home-content-shell"
					style={{
						display: "flex",
						flexDirection: "column",
						height: "100%",
						boxSizing: "border-box",
						width: "100%",
					}}
				>
					{!isMobileView && (
						<>
							<div style={{ paddingLeft: "30px", paddingRight: "0px" }}>
								<HeaderItem />
							</div>
							<div style={{ height: 20 }}>{""}</div>
						</>
					)}

					<div
						style={{
							// paddingTop: 0,
							width: "100%",
							minHeight: "calc(100dvh - 150px)",
							// maxHeight: "100%",
						}}
					>
						<Pages currentPage={currentPage} />
					</div>
					<ErrorModal />
					<Toast />
				</div>
			</div>
		</div>
	);
};

export default Home;
